export default {
  about: 'حول',
  addOns: 'الإضافات',
  agenda: 'جدول الأعمال',
  all: 'الكل',
  arrival: 'الوصول',
  at: 'في',
  availableTimes: 'الأوقات المتاحة',
  browse: 'تصفح',
  buyTickets: 'شراء التذاكر',
  cancellationPolicy: 'سياسة الإلغاء',
  checkOutOutOtherExperiences: 'اطلع على تجاربنا الأخرى!',
  continue: 'متابعة',
  countSelected: 'تم اختيار {{count}}',
  departure: 'المغادرة',
  from: 'من',
  included: 'مشمول',
  joining: 'جارٍ الانضمام',
  joinWaitlist: 'الانضمام إلى قائمة الانتظار',
  location: 'الموقع',
  menu: 'القائمة',
  nights: 'ليالٍ',
  noDatesAvailable: 'لا توجد تواريخ متاحة',
  noTimesAvailableOnThisDateFotThisPartySize:
    'لا توجد أوقات متاحة في هذا التاريخ لحجم المجموعة هذا',
  request: 'طلب',
  rsvp: 'تأكيد الحضور',
  salesEnded: 'انتهت المبيعات',
  schedule: 'الجدول',
  seeMoreDates: 'عرض المزيد من التواريخ',
  soldOut: 'نفدت التذاكر',
  tickets: 'التذاكر',
  ticketsAreNoLongerAvailable: 'لم تعد التذاكر متاحة.',
  time: 'الوقت',
  viewExperiences: 'عرض التجارب',
  viewLess: 'عرض أقل',
  viewMore: 'عرض المزيد',
  waitlist: 'قائمة الانتظار',
};
